import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import meetMark  from "../images/about_deb_bg.jpg";

const EmailSignupModal = ({ open, handleClose }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <Box sx={{ background: "#106cb7!important" }}>
        <DialogTitle sx={{ color: "white" }}>Join Our Email List</DialogTitle>
        <DialogContent>
          <form
            action="https://api.web3forms.com/submit"
            method="POST"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              paddingTop: "1rem",
            }}
          >
            <input
              type="hidden"
              name="access_key"
              value="f17cc4e5-e9b2-460c-8b30-495af7bd8830"
            />
            <TextField
              label="First Name"
              name="first_name"
              required
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Last Name"
              name="last_name"
              required
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              required
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Phone"
              name="phone"
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <TextField
              label="Zip Code"
              name="zip"
              fullWidth
              sx={{ background: "#FFFFFF", borderRadius: "4px" }}
            />
            <Box mt={2}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                sx={{
                  background: "#FFFFFF",
                  borderRadius: "4px",
                  color: "#2d7ebf",
                  fontSize: "18px",
                  fontWeight: "bold",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "#2d7ebf",
                    color: "#FFFFFF",
                  },
                }}
              >
                Submit
              </Button>
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "white" }}
              align="center"
              mt={2}
            >
              Join our email list keep up to date with the latest from Mark!
            </Typography>
          </form>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default EmailSignupModal;
